import { render, staticRenderFns } from "./rencaizixun.vue?vue&type=template&id=20722358&scoped=true"
import script from "./rencaizixun.vue?vue&type=script&lang=js"
export * from "./rencaizixun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20722358",
  null
  
)

export default component.exports